import React from "react";
import Timeline from "@/components/wedding/Timeline";
import { useI18n } from "@/lib/i18n";

export default function Programa() {
  const { t } = useI18n();
  return (
    <Timeline
      source="program"
      t={t}
      eyebrow={t.programa.eyebrow}
      title={t.programa.title}
      subtitle={t.programa.subtitle}
      testId="programa-page"
    />
  );
}
